import React from 'react'
import './services.css'
import { FaCheckCircle } from 'react-icons/fa'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container service__container'>
        <article className='service'>
          <div className='service__head'>
            <h3>UI/UX Design</h3>
          </div>

          <ul className='service__list'>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>User-centered interface design</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>User stories and journey mapping</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Content strategy and information architecture</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>User flow charts and system diagrams</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Conversion-focused design</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Trust-building interfaces</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Responsive and accessible design</p>
            </li>
          </ul>
        </article>

        <article className='service'>
          <div className='service__head'>
            <h3>Full-Stack Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Production-grade web applications</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Healthcare and enterprise systems</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>RESTful API development</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Database design and optimization</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Responsive design implementation</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Testing, debugging, and QA</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Git version control and CI/CD</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Custom web application development</p>
            </li>
          </ul>
        </article>

        <article className='service'>
          <div className='service__head'>
            <h3>Product & Systems</h3>
          </div>

          <ul className='service__list'>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>MVP development for startups</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>System architecture and design</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>AI-powered application integration</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Role-based access control systems</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Data storage and management</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Scalable architecture planning</p>
            </li>
            <li>
              <FaCheckCircle className='service__list-icon' />
              <p>Technical consulting</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services
